import { SearchStoreState } from '../types/search.types';

export const searchStoreStateInitial = (): SearchStoreState => ({
	caption: 'Search',
	value: '',
});
